import {
  createItem,
  readItems,
  readItem,
  updateItem,
  deleteItem,
} from "@directus/sdk";
import { getDirectusClient } from "../lib/directus";

const directus = getDirectusClient();

// Crear un nuevo proveedor
export const crearProveedor = async (proveedorData) => {
  try {
    const response = await directus.request(
      createItem("proveedores", {
        nombre: proveedorData.nombre,
        documento: proveedorData.documento,
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Obtener todos los proveedores
export const obtenerProveedores = async () => {
  try {
    const proveedores = await directus.request(
      readItems("proveedores", {
        fields: ["*"],
      })
    );
    return proveedores;
  } catch (error) {
    throw error;
  }
};

// Obtener un proveedor específico por ID
export const obtenerProveedor = async (id) => {
  try {
    const proveedor = await directus.request(
      readItem("proveedores", id, {
        fields: ["*"],
      })
    );
    return proveedor;
  } catch (error) {
    throw error;
  }
};

// Actualizar un proveedor
export const actualizarProveedor = async (id, proveedorData) => {
  try {
    const response = await directus.request(
      updateItem("proveedores", id, {
        nombre: proveedorData.nombre,
        documento: proveedorData.documento,
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Eliminar un proveedor
export const eliminarProveedor = async (id) => {
  try {
    await directus.request(deleteItem("proveedores", id));
    return true;
  } catch (error) {
    throw error;
  }
};
